// Sentry для igo-admin (Vue 3 + TypeScript).
// Активируется только при VITE_SENTRY_DSN — иначе no-op.

import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

export function initSentry(app: App, router?: Router): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) {
    console.info('[Sentry] disabled (no VITE_SENTRY_DSN)')
    return
  }

  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.MODE,
    release: `igo-admin@${import.meta.env.VITE_APP_VERSION || 'dev'}`,
    integrations: [
      router ? Sentry.browserTracingIntegration({ router }) : Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true
      })
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })

  console.info(`[Sentry] initialized (env: ${import.meta.env.MODE})`)
}
